import { useEffect, useState } from 'react'

export function useErrorHandling(errorMessages: string[]) {
  const [showErrors, setShowErrors] = useState(false)

  useEffect(() => {
    let timeout: NodeJS.Timeout

    if (errorMessages.length > 0) {
      setShowErrors(true)

      timeout = setTimeout(() => {
        setShowErrors(false)
      }, 3000)
    } else {
      setShowErrors(false)
    }

    return () => clearTimeout(timeout)
  }, [errorMessages])

  return { showErrors, setShowErrors }
}
